const freetour = {
  portugues: {
    title: 'Free Tour',
    subTitle: 'Tenha acesso a um ensaio completo e veja o que voce está perdendo.',
    buttonTitle: 'Confira agora o ensaio',
    benefits: 'Vantagens',
    subBenefits: 'Veja o que você <strong>GANHA</strong> assinando o Bella da Semana',
    listBenefits: [
      'HD photos',
      'Vídeos em 4K* (Ultra HD)',
      "Assista transmissões ao vivo dos ensaios sem censura",
      "Acesso à todas as Lives gravadas em 4K *(ULTRA HD) ",
      'Seção exclusiva só com pezinhos',
      'Ensaios Completos com fotos exclusivas',
      'Mais de 40.000 fotos e centenas de vídeos',
      'Bella Cloud: salve seus vídeos e fotos favoritas com total privacidade',
      'ASSINATURA SIGILOSA(o nome do Bella não aparece na fatura do seu cartão de crédito, nem em sua conta bancária).'
  ],
    PlansOrangeTitle: 'Assine já!',
    PlansBlackTitle: 'É fácil, rápido e seguro.',
    PlansSubTitle: 'Escolha o melhor plano para você e assine agora mesmo!',
    PlanValueDay: 'apenas',
    day: 'dia',
    current: 'R$',
    buttonSubscribe: 'Assine'
  },
  ingles: {
    title: 'Free Tour',
    subTitle: "Get access to a full essay and see what you've been missing.",
    buttonTitle: 'Check out the test now',
    benefits: 'Advantages',
    subBenefits: 'See what you <strong>GET</strong> by subscribing to Bella Club',
    listBenefits: [
      'HD photos',
      '4K* (Ultra HD) videos',
      'Watch live streams of uncensored rehearsals',
      'Access to all 4K *(ULTRA HD) recorded Lives',
      'Exclusive section only with delicate feet',
      'Full photoshoots with exclusive pictures',
      'Over 40,000 photos and hundreds of videos',
      'Bella Cloud: save your favorite videos and photos in complete privacy',
      "CONFIDENTIAL SUBSCRIPTION (Bella's name does not appear on his credit card statement or in his bank account)."
  ],
    PlansOrangeTitle: 'Subscribe now!',
    PlansBlackTitle: "It's easy, fast, and secure.",
    PlansSubTitle: 'Choose the best plan for you and subscribe right away!',
    PlanValueDay: 'just',
    day: 'day',
    current: '$',
    buttonSubscribe: 'SignUp'
  }
}

export default freetour
